import { render, staticRenderFns } from "./collapsible_commit_info.vue?vue&type=template&id=6a2336a4&vue3"
import script from "./collapsible_commit_info.vue?vue&type=script&lang=js&vue3"
export * from "./collapsible_commit_info.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports